import { localDateInputValue } from './replayTime';

export function replayTimestamp(value) {
  if (typeof value === 'number') {
    return Number.isFinite(new Date(value).getTime()) ? value : null;
  }
  if (typeof value !== 'string' || !value.trim()) return null;
  const text = value.trim();
  const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(text);
  const timestamp = new Date(hasTimeZone ? text : `${text}Z`).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function dayWindow(value) {
  const timestamp = replayTimestamp(value);
  if (timestamp === null) return null;
  const date = new Date(timestamp);
  const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
  return {
    day: localDateInputValue(start),
    start: start.getTime(),
    end: end.getTime(),
    startAt: start.toISOString(),
    endAt: end.toISOString(),
  };
}

function compareIds(a, b) {
  return String(a.replayId).localeCompare(String(b.replayId), 'en', { numeric: true });
}

export function prepareReplays(rows) {
  return rows.map((row) => ({
    ...row,
    start: replayTimestamp(row.startedAt),
    end: replayTimestamp(row.endedAt),
    verified: false,
  })).filter((row) => row.start !== null)
    .sort((a, b) => a.start - b.start || compareIds(a, b));
}

export function getReplayBounds(events) {
  let start = Infinity;
  let end = -Infinity;
  const visit = (items) => {
    for (const event of items) {
      if (Number.isFinite(event?.timestamp)) {
        start = Math.min(start, event.timestamp);
        end = Math.max(end, event.timestamp);
      }
      if (event?.type === 5 && event.data?.tag === 'cpt-emr') {
        const nested = event.data.payload?.events;
        if (Array.isArray(nested)) visit(nested);
      }
    }
  };
  visit(events);
  return start === Infinity ? null : { start, end };
}

export function selectRecordingAt(rows, timestamp, currentId) {
  let selected = null;
  for (const row of rows) {
    if (row.unavailable || row.start > timestamp || (row.end !== null && row.end <= timestamp)) continue;
    if (currentId !== undefined && String(row.replayId) === String(currentId)) return row;
    if (!selected || row.start > selected.start ||
      (row.start === selected.start && compareIds(row, selected) < 0)) {
      selected = row;
    }
  }
  return selected;
}

export function nextRecording(rows, timestamp, currentId) {
  const available = rows.filter((row) => !row.unavailable && String(row.replayId) !== String(currentId));
  const covering = selectRecordingAt(available, timestamp);
  if (covering) return { replay: covering, timestamp };
  let next = null;
  for (const row of available) {
    if (row.start <= timestamp || (row.end !== null && row.end <= row.start)) continue;
    if (!next || row.start < next.start || (row.start === next.start && compareIds(row, next) < 0)) next = row;
  }
  return next ? { replay: next, timestamp: next.start } : null;
}
